/**
* 基础菜单 动态属性管理
*/
<template>
  <div class="contianer">
    <!-- 面包屑导航 -->
    <!-- <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>商品管理</el-breadcrumb-item>
        <el-breadcrumb-item>动态属性管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="formInline.attr_name" placeholder="属性名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
         <el-cascader :options="productOptionsHome" :props="defaultParams" v-model="formInline.sort_id" placeholder="请选择分类"
                      @change="productSortChange(attrForm.sort_id)" clearable></el-cascader>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
        <el-button size="small" type="primary" @click="adddiscount" class="add-button">新增</el-button>
        <el-button size="small" type="primary" @click="editdiscount" class="edit-button">修改</el-button>
        <el-button size="small" type="danger" @click="deldiscount">删除</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 530px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                element-loading-text="拼命加载中" style="width: 70%;">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          width="60">
          <template slot-scope="scope">
            {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="attr_name" label="属性名称" min-width="220" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="sort3_name" label="商品分类" width="300" :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            <div class="over_text_1">{{scope.row.sort1_name+'-'+scope.row.sort2_name+'-'+scope.row.sort3_name}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="creater_name" label="创建人" width="180" >
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="150">
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               :title="dialogTitle"
               :visible.sync="attrDialogVisible"
               width="30%"
               :before-close="handleClose"
               center>
      <el-form label-width="155px" :model="attrForm" :rules="attrRules" ref="attrForm" class="attrForm">
        <el-form-item label="动态属性名称" prop="attr_name" class="relative r50">
          <el-input size="small" v-model="attrForm.attr_name" auto-complete="off" clearable maxlength="100"
                    placeholder="请输入动态属性名称"></el-input>
        </el-form-item>
        <el-form-item label="分类名称" prop="sort_id">
            <el-cascader :options="productOptions" :props="defaultParams" v-model="attrForm.sort_id"
                         @change="productSortChange(attrForm.sort_id)" clearable></el-cascader>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="saveSort('attrForm')" :disabled="!isCanSubmit"c>保存</el-button>
            <el-button @click="handleClose()">取 消</el-button>

      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
      attrList,
      attrAdd,
      attrUpdate,
      attrDetail,
      attrDelete,
      productTree,
      productBrand
  } from '../../api/basisMG'
  import Pagination from '../../components/Pagination'
  import {param} from '../../api/commonMG'

  export default {
    data: () => {
      return {
        loading: false, //是显示加载
        attrDialogVisible: false,  // 弹窗
        dialogTitle: '',  // 标题
        selectTableData: [],
        productId: '',
        productOptions: [],
        productOptionsHome: [],
        formInline: {
          page: 1,
          rows: 10,
          attr_name: '',
          sort_id: ''
        },
        attrRules: {
          attr_name: [{required: true, message: '请输入动态属性名称', trigger: 'blur'}],
          sort_id: [{required: true, message: '请选择分类', trigger: 'blur'}],
        },
        attrForm: {
          id: '',
          attr_name: '',
          sort_id: ''
        },
        defaultParams: {
          label: 'text',
          value: 'id',
          children: 'children'
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        isCanSubmit: true,
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
      productTree()
        .then(res => {
          if (res.success) {
            this.productOptionsHome = res.content
          }
        })
        .catch(err => {
        })
    },
    methods: {
      // 新增动态属性
      adddiscount() {
        this.attrDialogVisible = true;
        this.dialogTitle = '新增动态属性';
        this.attrForm = {};
        productTree()
          .then(res => {
            if (res.success) {
              this.productOptions = res.content;
            }
          })
          .catch(err => {
          })
      },
      // 修改动态属性
      editdiscount() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        this.dialogTitle = '修改动态属性';
        this.attrDialogVisible = true;
        productTree()
          .then(res => {
            if (res.success) {
              this.productOptions = res.content;
            }
          })
          .catch(err => {
          })
        this.productId = this.selectTableData[0].id;
        this.attrForm.attr_name = this.selectTableData[0].attr_name;
        this.attrForm.sort_id = this.selectTableData[0].sort3_id;
      },
      // 删除订单满减
      deldiscount() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        const title = '是否删除动态属性？';
        this.$confirm(title, '删除动态属性', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true;
          attrDelete(this.selectTableData[0].id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        attrList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getdata(this.formInline)
      },
      // 新增动态属性
      saveSort(formName) {
        if (this.attrForm.sort_id && typeof (this.attrForm.sort_id) != 'string') {
          this.attrForm.sort_id = this.attrForm.sort_id.pop()
        }
        if (this.dialogTitle == '修改动态属性') {
          this.attrForm.id = this.productId;
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isCanSubmit = false;
            this.loading = true;
            if (this.dialogTitle == '新增动态属性') {
              attrAdd(this.attrForm)
                .then(res => {
                  this.isCanSubmit = true;
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功增加动态属性!'
                    });
                    this.handleClose()
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.isCanSubmit = true;
                  this.loading = false
                  this.$message.error('网络错误，请稍后再试！')
                })
            } else {
              attrUpdate(this.attrForm)
                .then(res => {
                  this.isCanSubmit = true;
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功修改动态属性!'
                    });
                    this.handleClose()
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.isCanSubmit = true;
                  this.loading = false
                  this.$message.error('网络错误，请稍后再试！')
                })
            }
          } else {
            console.log('error submit!!');
          }
        });
      },
      productSortChange(sort_id, type) {

      },
      // 搜索事件
      search() {
        if (this.formInline.sort_id && typeof (this.formInline.sort_id) != 'string') {
          this.formInline.sort_id = this.formInline.sort_id.pop()
        }
        this.formInline.page = 1;
        this.getdata(this.formInline)
      },
      handleRemove(file) {
        console.log(file);
      },
      handleSelectionChange(val) {
        this.selectTableData = val
      },
      handleClose() {
        this.$refs["attrForm"].resetFields();
        this.attrDialogVisible = false;
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.attr_name == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      }
    }
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  /deep/ .textarea .el-textarea__inner {
    resize: none;
  }

  /deep/ .r55 .el-input__suffix {
    right: 55px !important;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  /deep/ .attrForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .attrForm .el-input {
    width: 320px;
  }

  /deep/ .attrForm .el-input--small {
    width: 320px;
  }

  /deep/ .textarea .el-textarea__inner {
    resize: none;
  }

  /deep/ .attrForm .el-form-item__label {
    position: relative;
    padding: 0 22px 0 0 !important;
  }

  /deep/ .attrForm .el-select-dropdown__list {
    padding-bottom: 50px;
    min-height: 150px;
  }

  /deep/ .attrForm .el-select-dropdown__item {
    width: 320px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  /deep/ .attrForm .el-input--small {
    width: 320px;
  }

  .add-button {
    background: #53B03C;
    border-color: #53B03C;
  }

  .edit-button {
    background: #58B7D6;
    border-color: #58B7D6;
  }

  .pagination-absolute {
    position: absolute;
    bottom: 0;
    background: #fff;
    width: 95%;
    padding-left: 20px;
    height: 40px;
  }

  /deep/ .el-dialog--center {
    border-radius: 8px !important;
  }

  /deep/ .el-message-box__title {
    color: #409EFF !important;
  }

  /deep/ .el-dialog__title {
    color: #409EFF !important;
  }

</style>





// WEBPACK FOOTER //
// src/views/goods/GoodAttr.vue